import { RECEIVED_OPPORTUNITY_COUNT } from '../actions/GetOpportunityCount';
import { UPDATE_OPPORTUNITY_COUNT } from '../actions/UpdateOpportunityCount';

const initialState = {
  loaded: false,
  count: 0,
};

const opportunityCount = (state = initialState, action) => {
  switch (action.type) {
    case RECEIVED_OPPORTUNITY_COUNT:
      return {
        loaded: true,
        count: action.count,
      };
    case UPDATE_OPPORTUNITY_COUNT:
      return {
        loaded: true,
        count: action.count,
      };
    default:
      return state;
  }
};

export default opportunityCount;
